module.exports = __webpack_public_path__ + "static/media/pic_dianli_wap.d31763fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/page_temperature/pic_dianli_wap.png
// module id = 490
// module chunks = 0